
import { onLogout } from '@/vue-apollo';

import { useAuthActions, useUserActions, useUserGetters } from '@/store';
import Profile from '@/components/Profile.vue';
import SetupWizard from '@/views/Guide/components/SetupWizard/SetupWizard.vue';
import { computed, ref, getCurrentInstance } from 'vue';

export default {
  components: {
    Profile,
    SetupWizard
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  setup(_props, ctx) {
    const instance = getCurrentInstance();
    const { logout: logoutProcess } = useAuthActions(['logout']);
    const { getUser } = useUserGetters(['getUser']);
    const user = computed({
      get: () => getUser.value,
      set: newVal => {
        ctx.emit('input', newVal);
      }
    });
    const permissions = computed({
      get: () => localStorage?.getItem('permissions')?.split(',') || [],
      set: newVal => {
        ctx.emit('input', newVal);
      }
    });
    const logout = async () => {
      await logoutProcess();
      await onLogout();
      // instance?.proxy?.$router.push({ name: 'login' });
      window.location.href = '/login';
    };
    const isSetupWizardOpen = ref(false);
    const userTypeValues = ref(['Employer', 'Teacher', 'Parent', 'School']);
    
    const menuList = ref(false);
    const openMenu = () => {
      menuList.value = !menuList.value;
    };
    
    return {
      logout,
      user,
      isSetupWizardOpen,
      permissions,
      userTypeValues,
      menuList,
      openMenu
    };
  },

  data() {
    return {
      menuList: false
    };
  },

  methods: {
    openMenu() {
      this.menuList = !this.menuList;
    }
  }
};
